export const StudentTicketsTranslations = {
  QUESTIONS: {
    es: 'Preguntas',
    en: 'Questions',
    cat: 'Preguntes',
    eus: 'Galderak',
    pt: 'Perguntas'
  },
  DOUBTS: {
    es: 'Dudas',
    en: 'Doubts',
    cat: 'Dubtes',
    eus: 'Zalantzak',
    pt: 'Dúvidas'
  },
  OPEN_DOUBT: {
    es: 'Abrir duda',
    en: 'Open doubt',
    cat: 'Obre dubte',
    eus: 'Ireki zalantza',
    pt: 'Abrir dúvida'
  },
  FILTER: {
    es: 'Filtrar',
    en: 'Filter',
    cat: 'Filtra',
    eus: 'Iragazi',
    pt: 'Filtrar'
  },
  SEND: {
    es: 'Enviar',
    en: 'Send',
    cat: 'Envia',
    eus: 'Bidali',
    pt: 'Enviar'
  },
  SUBJECT: {
    es: 'Asunto',
    en: 'Subject',
    cat: 'Assumpte',
    eus: 'Gaia',
    pt: 'Assunto'
  },
  WRITE_HERE_YOUR_DOUBT: {
    es: 'Escribe aquí tu duda',
    en: 'Write here your doubt',
    cat: 'Escriu aquí el teu dubte',
    eus: 'Idatzi hemen zure zalantza',
    pt: 'Escreva aqui a sua dúvida'
  },
  COURSE: {
    es: 'Curso',
    en: 'Course',
    cat: 'Curs',
    eus: 'Ikastaroa',
    pt: 'Curso'
  },
  TICKET_CREATED_SUCCESSFULLY: {
    es: 'Ticket creado correctamente',
    en: 'Ticket created successfully',
    cat: 'Ticket creat correctament',
    eus: 'Ticketa ongi sortu da',
    pt: 'Ticket criado com sucesso'
  },
  SET_TICKET_AS_RESOLVED: {
    es: 'Marcar como resuelta',
    en: 'Set as resolved',
    cat: 'Marcar com a resolt',
    eus: 'Markatu ebaztuta',
    pt: 'Marcar como resolvido'
  },
  TICKET_HAS_BEEN_SET_AS_RESOLVED: {
    es: 'El ticket ha sido marcado como resuelto',
    en: 'The ticket has been set as resolved',
    cat: 'El ticket ha estat marcat com a resolt',
    eus: 'Ticketa ebaztuta markatu da',
    pt: 'Ticket resolvido'
  },
  DESCRIPTION_REQUIRED: {
    es: 'La descripción es requerida',
    en: 'Description is required',
    cat: 'La descripció és requerida',
    eus: 'Deskribapena beharrezkoa da',
    pt: 'Descrição é obrigatória'
  },
  DELIVER: {
    es: 'Entregar',
    en: 'Deliver',
    cat: 'Lliurar',
    eus: 'Entregatu',
    pt: 'Entregar'
  },
  CSAT_RATING_TITLE: {
    es: '¿Estás satisfecho con la resolución de tu duda?',
    en: 'Are you satisfied with the resolution of your doubt?',
    cat: 'Estàs satisfet amb la resolució del teu dubte?',
    eus: 'Zalantzaren ebazpenarekin pozik zaude?',
    pt: 'Você está satisfeito com a resolução da sua dúvida?'
  },
  CSAT_RATING_SUBTITLE: {
    es: 'Tu feedback nos sirve para mejorar',
    en: 'Your feedback helps us improve',
    cat: 'El teu feedback ens serveix per millorar',
    eus: 'Zure feedbackak hobetzen laguntzen digu',
    pt: 'O seu feedback ajuda-nos a melhorar'
  },
  THANKS_FOR_YOUR_FEEDBACK: {
    es: 'Gracias por tu feedback 😊',
    en: 'Thanks for your feedback 😊',
    cat: 'Gràcies pel teu feedback 😊',
    eus: 'Mila esker zure feedbackagatik 😊',
    pt: 'Muito obrigado pelo seu feedback 😊'
  },
  COURSE_REQUIRED: {
    es: 'El curso es requerido',
    en: 'Course is required',
    cat: 'El curs és requerit',
    eus: 'Ikastaroa beharrezkoa da',
    pt: 'O curso é obrigatório'
  },
  TEACHER_QUESTIONS_SAVED_HERE: {
    es: 'Las preguntas que hagas a los profes dentro de las lecciones se irán guardando aquí.',
    en: 'The questions you ask teachers within lessons will be saved here.',
    cat: 'Les preguntes que facis als profes dins de les lliçons es guardaran aquí.',
    eus: 'Irakasleei lekzioetan egiten dizkizun galderak hemen gordeko dira.',
    pt: 'As perguntas que fizer aos professores nas lições serão guardadas aqui.'
  },
  HOW_TO_ASK_A_QUESTION: {
    es: '¿Cómo hacer una pregunta?',
    en: 'How to ask a question?',
    cat: 'Com fer una pregunta?',
    eus: 'Nola galdetu?',
    pt: 'Como fazer uma pergunta?'
  },
  YOU_DIDNT_ASK_ANY_QUESTIONS: {
    es: 'Aún no has hecho ninguna pregunta',
    en: "You didn't ask any questions",
    cat: 'Encara no has fet cap pregunta',
    eus: 'Ez zenuen galdera bat egin',
    pt: 'Você não fez nenhuma pergunta'
  },
  TO_RESOLVE_ANY_QUESTION: {
    es: 'Las preguntas que hagas en las lecciones se irán guardando aquí para que puedas revisarlas cuando necesites.',
    en: 'The questions you make in the lessons will be saved here so you can review them when you need.',
    cat: 'Les preguntes que fas en les lliçons es guardaran aquí perquè puguis revisar-les quan necessitis.',
    eus: 'Lekziorako egin dituzun gaietako gai guztiak hemen gordetu dira, beraz, behar duzun unean ebatzi ditzakezu.',
    pt: 'As perguntas que faz nos temas de estudo serão salvas aqui para que você possa revisá-las quando precisar.'
  },
  WRITE_ANSWER: {
    es: 'Escribe tu respuesta',
    en: 'Write your answer',
    cat: 'Escriu la teva resposta',
    eus: 'Idatzi zure erantzuna',
    pt: 'Escreva sua resposta'
  },
  HOW_TO_ASK_INTRO: {
    es: 'Si quieres preguntarle una duda a tu profe, debes hacerla en la pestaña "Preguntas" dentro de la lección:',
    en: 'If you want to ask your teacher a question, you should do it in the "Questions" tab within the lesson:',
    cat: 'Si vols fer una pregunta al teu professor, has de fer-la a la pestanya "Preguntes" dins de la lliçó:',
    eus: 'Irakasleari galdera bat egin nahi badiozu, lekzioaren barruko "Galderak" fitxan egin behar duzu:',
    pt: 'Se você quiser fazer uma pergunta ao seu professor, deve fazê-la na aba "Perguntas" dentro da lição:'
  },
  HOW_TO_ASK_STEP_1: {
    es: 'Entra al curso.',
    en: 'Go to the course.',
    cat: 'Entra al curs.',
    eus: 'Sartu ikastarora.',
    pt: 'Entre no curso.'
  },
  HOW_TO_ASK_STEP_2: {
    es: 'Dirígete al tema y elige la lección sobre la que tienes dudas.',
    en: 'Go to the topic and choose the lesson you have questions about.',
    cat: 'Dirigeix-te al tema i tria la lliçó sobre la qual tens dubtes.',
    eus: 'Joan gaira eta aukeratu zalantzak dituzun lekzioa.',
    pt: 'Vá para o tema e escolha a lição sobre a qual você tem dúvidas.'
  },
  HOW_TO_ASK_STEP_3: {
    es: 'En la pestaña "Preguntas", escribe tu duda y el profesor te responderá cuanto antes.',
    en: 'In the "Questions" tab, write your question and the teacher will answer you as soon as possible.',
    cat: 'A la pestanya "Preguntes", escriu el teu dubte i el professor et respondrà com més aviat millor.',
    eus: '"Galderak" fitxan, idatzi zure zalantza eta irakasleak ahalik eta lasterren erantzungo dizu.',
    pt: 'Na aba "Perguntas", escreva sua dúvida e o professor responderá o mais breve possível.'
  },
  TICKET_CONFIRMED_AS_RESOLVED: {
    es: 'Duda confirmada como resuelta',
    en: 'Doubt confirmed as resolved',
    cat: 'Dubte confirmat com a resolt',
    eus: 'Zalantza ebaztuta baieztatu da',
    pt: 'Dúvida confirmada como resolvida'
  },
  IS_YOUR_DOUBT_RESOLVED: {
    es: '¿Tu duda está resuelta?',
    en: 'Is your doubt resolved?',
    cat: 'El teu dubte està resolt?',
    eus: 'Zure zalantza ebaztuta dago?',
    pt: 'Sua dúvida está resolvida?'
  },
  TEACHER_MARKED_AS_RESOLVED: {
    es: '{{name}} marcó tu pregunta como resuelta. Confírmalo o indica si necesitas más ayuda.',
    en: '{{name}} marked your question as resolved. Confirm it or indicate if you need more help.',
    cat: '{{name}} ha marcat la teva pregunta com a resolta. Confirma-ho o indica si necessites més ajuda.',
    eus: '{{name}}-(e)k zure galdera ebaztuta markatu du. Baieztatu edo adierazi laguntza gehiago behar duzun.',
    pt: '{{name}} marcou sua pergunta como resolvida. Confirme ou indique se precisa de mais ajuda.'
  },
  TICKET_MARKED_AS_RESOLVED: {
    es: 'Se marcó tu pregunta como resuelta. Confírmalo o indica si necesitas más ayuda.',
    en: 'The question was marked as resolved. Confirm it or indicate if you need more help.',
    cat: 'La teva pregunta va ser marcada com a resolta. Confirma-ho o indica si necessites més ajuda.',
    eus: 'Zure galdera ebaztuta markatu da. Baieztatu edo adierazi laguntza gehiago behar duzun.',
    pt: 'Sua pergunta foi marcada como resolvida. Confirme ou indique se precisa de mais ajuda.'
  },
  STILL_HAVE_DOUBTS: {
    es: 'Aún tengo dudas',
    en: 'I still have doubts',
    cat: 'Encara tinc dubtes',
    eus: 'Oraindik zalantzak ditut',
    pt: 'Ainda tenho dúvidas'
  },
  YES_ITS_RESOLVED: {
    es: 'Sí, está resuelta',
    en: "Yes, it's resolved",
    cat: 'Sí, està resolt',
    eus: 'Bai, ebaztuta dago',
    pt: 'Sim, está resolvido'
  }
};
